import { defineStore } from "pinia";
import api from "@/services/api";

export const useConfigStore = defineStore("config", {
    state: () => ({
        configs: [],
        loading: false,
    }),

    persist: true,

    actions: {
        async fetchConfig() {
            const res = await api.get('/config');
            
            this.configs = res.data.data;
        },
        reset() {
            this.configs = [];
        }
    },
});